<template>
  <div class="home">
    <div class="banner"><img src="../assets/images/banner.png">
    </div>
    <div class="fillSide">
      <div class="fill">
        <img src="../assets/images/fill.png">
      </div>
      <div class="content">
        <div class="left">
            <div class="block">
              <el-carousel height="400px">
                <el-carousel-item v-for="item in carouse" :key="index">
                  <a :href="item.OutLink">
                    <img :src="'http://lishui.yeshiweb.com:8081/'+item.ImgPath">
                    <h3 class="small">{{ item.Title }}</h3>
                    </a>
                </el-carousel-item>
              </el-carousel>
            </div>
        </div>
        <div class="right">
          <el-tabs :tab-position="tabPosition">
            <el-tab-pane label="畲乡头条">
                <tabhome :col_ids='[195]'></tabhome>
            </el-tab-pane>
            <el-tab-pane label="习语讲堂"><tabhome :col_ids='[46,72,71]'></tabhome></el-tab-pane>
            <el-tab-pane label="印象畲乡"><tabhome :col_ids='[196]'></tabhome></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <div class="yczSide">
      <div class="top"><img src="../assets/images/yz.png"></div>
      <div class="content">
        <ul>
          <li v-for="(item,index) in chuzhou" :key="index">
            <img v-if="item.Ico1" :src="'http://lishui.yeshiweb.com:8081/'+item.Ico1">
            <h3>{{item.ArtTitle}}</h3>
            <p class="type_">{{item.Created}}
                <a class="more" v-if="item.ShowType == 2" :href="'http://lishui.yeshiweb.com:8081/web//Detail/VideoDetail?col_id='+item.ColId+'&art_id='+item.Id">更多内容</a>
                <router-link class="more" v-else-if="item.ShowType == 1" :to="{ path: '/artical',query:{colid:item.Id}}">
               更多内容</router-link></p>
          </li>
        </ul>
      </div>
    </div>

    <div class="stageSide">
      <div class="top"><img src="../assets/images/stage.png"></div>
      <ul>
        <li><router-link to="/filling?id=1">
          <img src="../assets/images/stage1.png">
          <p>工作动态</p>
          </router-link></li>
        <li><router-link to="/filling?id=1">
          <img src="../assets/images/stage2.png">
          <p>文化活动</p>
          </router-link></li>
        <li><a href="http://lishui.yeshiweb.com:8081/jingningweb/pc/halllive.html">
          <img src="../assets/images/stage3.png">
          <p>礼堂直播</p>
          </a></li> 
        <li><router-link to="/filling?id=1">
          <img src="../assets/images/stage5.png">
          <p>视频展播</p>
          </router-link></li>           
          <li><a href="http://lishui.yeshiweb.com:8081/jingningweb/pc/actilive.html">
          <img src="../assets/images/stage6.png">
          <p>活动直播</p>
          </a></li>           
      </ul>
    </div>

    <div class="serveSide">
      <div class="top"><img src="../assets/images/shiming.png"></div>
      <ul>
        <li><a href="http://lskp.lishui.gov.cn/" target="_blank"></a></li>
        <li><a href="https://www.91160.com/unit/show/uid-200046860.html" target="_blank"></a></li>
        <li><a href="javascript:void(0);"></a></li>
        <li><a href="http://www.15weather.org/weizhang/lishuijingning/"></a></li>
        <li><a href="http://zjzfgjjgd.yyhj.zjzwfw.gov.cn/"></a></li>
        <li><a href="http://www.zjzwfw.gov.cn/zjservice/front/index/page.do?webId=93" target='_blank'></a></li>
      </ul>
    </div>
    <div class="area">
      <ul>
        <li><a class="focus" href="http://lishui.yeshiweb.com:8081/dist/index.html#/">丽水</a></li>
        <li><a href="javascript:void(0);">莲都区</a></li>
        <li><a href="javascript:void(0);">青田县</a></li>
        <li><a href="javascript:void(0);">缙云县</a></li>
        <li><a href="javascript:void(0);">遂昌县</a></li>
        <li><a href="javascript:void(0);">松阳县</a></li>
        <li><a href="javascript:void(0);">云和县</a></li>
        <li><a href="javascript:void(0);">庆元县</a></li>
        <li><a href="javascript:void(0);">龙泉市</a></li>
      </ul>
    </div>
    <div class="btm"></div>
  </div>
</template>

<script>
import api from '../assets/config/api'
import axios from 'axios'
import tabhome from '../../src/components/TabHome'

export default {
  name: 'hoome',
  data() {
    return {
      carouse:'',
      tabPosition: 'right',
      chuzhou:''
    }
  },
  components: {
    tabhome
  },
  async mounted() {
    await axios.post(api.carImg, {
        col_id:1217
    })
    .then(response => {
        //console.log(response.data.Items);
        this.carouse = response.data.Items
    })
    .catch(function (error) {
        console.log(error);
    });
    await axios.post(api.atrDetail, {
        col_ids:[209],page_index:1,page_size:3
    })
    .then(response => {
        //console.log(response.data.Items);
        this.chuzhou = response.data.Items
    })
    .catch(function (error) {
        console.log(error);
    });
  },
}
</script>
<style lang="less">
  .home{
    min-width: 1200px;
  }
  .banner{
    position: relative;
    width: 100%;
    img{
      width: 100%;
    }
    .location{
          margin-top: -120px;
          z-index: 99999999999;
          p{
            width: 1200px;
            height: 80px;
            margin: 0 auto;
            background: url(../assets/images/locat.png);
            line-height: 80px;
            color: #999;
            font-size: 22px;
            padding-left: 70px;
            z-index: 9999999;
          };
    }

  }

  .fillSide{
    overflow: hidden;
      .top{
        width: 1200px;
        margin: 0 auto;
        text-align: center;
      }
      .fill{
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        padding: 0 0 40px;
        
      }
      .content{
        width: 1200px;
        margin: 0 auto;
        .left{
          width: 520px;
          height: 520px;
          float: left;
          a{
            display: block;
          }
          img{
            width: 520px;
            height: 400px;
            border-radius: 10px;
          }
          h3{
            position: absolute;
            bottom: 0;
            left: 0;
            line-height: 65px !important;
            width: 100%;
            height: 65px !important;
            overflow: hidden;
            font-size: 22px !important;
            color: #fff !important;
            font-weight: normal;
            padding-left: 20px;
            background: #000;
          }
          .el-carousel__container{
            border-radius: 10px;
          }
          .el-carousel__button{
            width: 10px;
            height: 10px;
            border-radius: 5px;
          }
          .el-carousel__item{
            border-radius: 10px;
          }
          .el-carousel__item h3 {
            color: #475669;
            font-size: 14px;
            opacity: 0.75;
            line-height: 150px;
            margin: 0;
          }

          .el-carousel__item:nth-child(2n) {
            background-color: #99a9bf;
            border-radius: 10px;
          }
          
          .el-carousel__item:nth-child(2n+1) {
            background-color: #d3dce6;
            border-radius: 10px;
          }
          .el-carousel__indicators--horizontal{
            bottom: 10px;
            left:85%
          }
        }
        .right{
          width: 642px;
          float: right;
          .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after{
              height: 0 !important;
          }
          .el-tabs__content{
            border: 2px solid #faa27a;
            border-radius: 10px 0 0 10px;
            padding: 27px;
            height: 392px !important;
          }
          .el-tabs--right .el-tabs__header.is-right{
            margin-left: 0 !important;
          }
          .el-tabs__item{
              width: 42px !important;
              height: 110px !important;
              line-height: 42px !important;
              font-size: 16px !important;
              text-align: center !important;
              border: 2px solid #faa27a;
              writing-mode:tb-rl;
              font-weight: normal !important;
              margin-bottom: 15px !important;
              border-left: 0;
              color: #faa27a;
              border-radius: 0 10px 10px 0;
              padding: 0 !important;
          }
          .is-active {
              color: #fff !important;
              background: #eb3613;
              border: 0 !important;
          }
          .el-tabs__active-bar{
            display: none;
          }
        }
      }
      .el-tabs__item.is-active{
        color: red;
      }
  }

  .yczSide{
    background: url(../assets/images/bg11.png) no-repeat 0 0;
    background-size: 19.2rem;
    height: 11.12rem;
    .top{
        width: 12rem;
        margin: 0 auto;
        text-align: center;
        padding: 0.7rem 0;
    }
    ul{
      width: 1230px;
      margin: 0 auto;
      overflow: hidden;
      li{
          float: left;
          width: 380px;
          margin-right: 30px;
          border-radius: 10px;
        img{
          width: 380px;
          height: 238px;
          border-radius: 10px 10px 0 0;
        }
        h3{
          line-height: 45px;
          height: 45px;
          overflow: hidden;
          background: #fff;
          padding: 0 20px;
          font-size: 18px;
          font-weight: normal;
        }
        p{
          position: relative;
          line-height: 28px;
          background: #fff;
          padding: 0 20px 20px;
          border-radius: 10px;
          color: #666;
          font-size: 14px;
          a{
            width: 72px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border-radius: 12px;
            color: #999;
            font-size: 14px;
            display: block;
            border: 1px solid #999;
            position: absolute;
            top: 0;
            right: 20px;
          }
        }
      }
    }
  }

  .stageSide{
    padding: 30px 0 80px;
    .top{
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        padding: 40px 0;
    }
    ul{
      overflow: hidden;
      width: 1220px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      li{
        padding: 0 10px;
        text-align: center;
        p{
          line-height: 44px;
          font-size: 22px;
        }
      }
    }
  }

  .serveSide{
    background: url(../assets/images/smside.png) no-repeat;
    background-size: 100%;
    .top{
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        padding: 40px 0;
    }
    ul{
      width: 1200px;
      margin: 0 auto;
      background: url(../assets/images/smitems.png) no-repeat 74px 0;
      overflow: hidden;
      padding-bottom: 70px;
      li{       
        float: left;
        a{
          display: block;
          width: 135px;
          height: 135px;
          padding-right: 60px;
        }
      }
    }
  }

  .area{
    padding: 45px 0;
    ul{
      overflow: hidden;
      width: 1200px;
      margin: 0 auto;
      li{
          float: left;
        a{
          display: block;
          width: 104px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 20px;
          margin-right: 29px;
          background: url(../assets/images/area1.png) no-repeat;
          &.focus{
            background: url(../assets/images/area.png) no-repeat;
            color: #fff;
          }
        }
      }
    }
  }
  .btm{
    background: url(../assets/images/btm.png) no-repeat 0 0;
    background-size: 19.2rem;
    height: 2.04rem;
  }
</style>
